import { ExtendedTragArmSystemInfo } from 'hcosmos-api-data'
import { defineStore, storeToRefs } from 'pinia'
import { ref } from 'vue'
import { pinia } from '..'
import { createFetchTragarms } from './fetchTragarms'
import { createCreateSystemWithTragarm, createDeleteTragArmSystem } from './createSystemWithTragarm'

export const useTragarmStore = defineStore(
  'tragarmStore',
  () => {
    const tragarms = ref<ExtendedTragArmSystemInfo[]>([])

    return {
      tragarms,
      fetchTragarms: createFetchTragarms(tragarms),
      createSystemWithTragarm: createCreateSystemWithTragarm(),
      deleteTragArmSystem: createDeleteTragArmSystem()
    }
  },
  {
    dummyValue: {
      fetchTragarms: async (store) => {
        store.tragarms = []
        return []
      },
    },
    authenticated: {
      fetchTragarms: true,
    },
  },
)

export const injectTragarms = () => {
  return useTragarmStore(pinia).fetchTragarms()
}

export const injectTragarmRefs = () => storeToRefs(useTragarmStore(pinia))